module.exports = __webpack_public_path__ + "static/assets/f9306dc2516652d6439d3a9711d57e70.png";